"use client";
import React, { useCallback } from "react";
import Icon from "../../common/components/Icon";
import * as matomo from "../../analytics/utils/matomo";
import Obfuscate from "../../common/components/Obfuscate";
import { useTranslations } from "next-intl";
import Link from "next/link";

const ContactBar = () => {
  const t = useTranslations();
  const clickEventTracker = useCallback((action) => {
    return () => {
      matomo.trackEvent("Contact Bar Click", action, document.location.href);
    };
  }, []);
  return (
    <div className="contact-bar">
      <Obfuscate
        className="contact-bar__item"
        onClick={clickEventTracker("call_us_button_click")}
        href="tel:+41564841500"
        aria-label={t("call_us")}
      >
        <div>
          <span>
            {t("call_us")}{" "}
            <Obfuscate element="span">{t("contact_us_number")}</Obfuscate>
          </span>
        </div>
        <Icon icon="phone" />
      </Obfuscate>
      <Obfuscate
        className="contact-bar__item"
        href="mailto:info@publicare.ch"
        onClick={clickEventTracker("email_button_click")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("email_us")}
      >
        <div>
          <span>{t("email_us")}</span>
        </div>
        <Icon icon="letter" fill="#FFFFFF" />
      </Obfuscate>
      <Link
        type="button"
        className="no-button contact-bar__item align-items-center"
        onClick={() => {
          clickEventTracker("callback_button_click")();
        }}
        href="call-back"
        aria-label={t("callback_us")}
      >
        <div>
          <span>{t("callback_us")}</span>
        </div>
        <Icon icon="phone-time" />
      </Link>
    </div>
  );
};
export default ContactBar;
